import { EpimsBaseEntityDto } from './epim-base.dto';
import { IsNotEmpty } from 'class-validator';

export class UserDto extends EpimsBaseEntityDto {
  
	
	id: string;
	Id: string;
	@IsNotEmpty() UserName: string;
	@IsNotEmpty() PhoneNo: string;

	password: string;

	Email: string;
	UserType: string;
	SubscriberName: string;
	FirstName: string;
	LastName: string;
	MiddleName: string;
	StaffName: string;
	Logo: string;
	VerifyStatus: string;
	IsConfirmed: string;
	UIN: string;
	NewUser: string;
	spouseName: string;
	noOfChildren: number;
	address: string;
	gender: string;
	ocupation: string;
	userRole: string;
	slogan: string;
	siteId: string;
	siteName: string;
	siteNumber: string;
	levelCount: number;
	canAddSub: boolean;
	siteGenericNumber: string;
	systemAdminStatus: string;
	resetPasswordToken: string;
	resetPasswordExpires?: Date;
	ParentId: string;

	//   @IsNotEmpty()
	//   VitalSignCode: string;
}

export class UserRO {
	id: string;
	username: string;
	phoneNo: string;
	token?: string;
	email: string;
	userType: string;
	subscriberName: string;
	firstName: string;
	lastName: string;
	middleName: string;
	StaffName: string;
	logoURL: string;
	verifyStatus: string;
	isConfirmed: string;
	UIN: string;
	newUser: string;
	spouseName: string;
	noOfChildren: number;
	address: string;
	gender: string;
	ocupation: string;
	slogan: string;
	siteId: string;
	siteName: string;
	siteNumber: string;
	levelCount: number;
	canAddSub: boolean;
	siteGenericNumber: string;
	systemAdminStatus: string;
	resetPasswordToken: string;
	resetPasswordExpires?: Date;
	parentId: string;
	userRole: string;
}

export class Credentials {
	username: string;
	password: string;
	UIN: string;
}
